import { render, staticRenderFns } from "./SupportAgentCard.vue?vue&type=template&id=7c6a0054&scoped=true"
import script from "./SupportAgentCard.vue?vue&type=script&lang=js"
export * from "./SupportAgentCard.vue?vue&type=script&lang=js"
import style0 from "./SupportAgentCard.vue?vue&type=style&index=0&id=7c6a0054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a0054",
  null
  
)

export default component.exports